module.exports = __webpack_public_path__ + "static/media/12UNCTAD16.e3b1daed.jpg";